// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m1-1";
export var messageSideRight = "_m1-2";
export var orderLookupBubbleContainer = "_m1-0";
export var submitButton = "_m1-3";